import { PriceStyle } from "@omni/ui/components/Price/price.style";
import { isDefined } from "@omni/utils/helper.utils";

import { usePriceContext } from "@/components/Price/context/price.context";
import { formatPrice } from "@/utils/price.utils";

type Props = {
    className?: string;
};

export const StrikeThrough = ({ className }: Props) => {
    const { strikeThroughPrice, size } = usePriceContext();

    const formattedPrice = isDefined(strikeThroughPrice)
        ? formatPrice(strikeThroughPrice)
        : "";

    return (
        <span
            className={PriceStyle.strikeThrough({
                size: size,
                className: className
            })}
        >
            {formattedPrice}
        </span>
    );
};
